export default __webpack_public_path__ + "media/call_to_action/ios_app_full-05a1ecce.png";